module.exports = __webpack_public_path__ + "static/img/star-small.3020a6e0.webp";